import { ITranslationItem, ITranslationItems } from './language.types';

interface CheckboxTranslation {
  label: ITranslationItem;
  errorLabel: ITranslationItem;
}

export const stepHeaderCounterLabel = (
  currentStep?: number,
  maxSteps?: number
): ITranslationItems => ({
  counter: {
    nl: `Stap ${currentStep} van ${maxSteps}`,
    en: `Step ${currentStep} of ${maxSteps}`,
  },
});

export const TEXT_AREA_TRANSLATIONS: CheckboxTranslation = {
  label: {
    nl: 'Vul hier je antwoord in',
    en: 'Enter your answer here',
  },
  errorLabel: {
    nl: 'Dit veld is verplicht',
    en: 'This field is required',
  },
};

export const ARTICLE_RESULTS: ITranslationItems = {
  title: {
    nl: 'Voor jouw sector',
    en: 'For your industry',
  },
};

export const GENERIC_LABELS: ITranslationItems = {
  start: {
    nl: 'Start',
    en: 'Start',
  },
};

export const RESULT_LABELS: ITranslationItems = {
  resetCopy: {
    nl: 'Niet tevreden met je keuzes? Beantwoord de ',
    en: 'Not satisfied with your choices? Answer the ',
  },
  resetButton: {
    nl: 'vragen opnieuw',
    en: 'questions again',
  },
  resultSubtitle: {
    nl: 'Relevante inzichten & producten voor jouw bedrijf',
    en: 'Related insights & products for your business',
  },
  noResultsSubtitle: {
    nl: 'Geen resultaten gevonden',
    en: 'No results found',
  },
  noResultsCopy: {
    nl: 'Beantwoord de ',
    en: 'Answer the ',
  },
  noResultsButtonLabel: {
    nl: 'Overnieuw',
    en: 'Try again',
  },
  hasResultsButtonLabel: {
    nl: 'Bekijk mijn persoonlijke producten',
    en: 'View my personal products',
  },
};
